import { documentoDaPrevia, type Pagina } from "@/components/production/etiquetas";

/**
 * A etiqueta como vai sair, montada pelo mesmo código da impressão (com dados de exemplo). Num
 * iframe: o CSS de impressão (mm, @page) não vaza pra tela de Configurações.
 */
export function PreviaDaEtiqueta({ pagina, a4, altura }: { pagina: Pagina; a4: boolean; altura?: number }) {
  return (
    <div className="space-y-1.5 lg:sticky lg:top-4">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">Prévia</p>
      <iframe
        title="Prévia da etiqueta"
        srcDoc={documentoDaPrevia(pagina)}
        className="w-full rounded-lg border border-zinc-200 bg-zinc-200 dark:border-border"
        style={{ height: altura ?? (a4 ? 420 : 300) }}
      />
      <p className="text-[11px] text-zinc-500 dark:text-muted-foreground">
        Tamanho real na impressão. Dados de exemplo — nenhum pedido é usado.
      </p>
    </div>
  );
}
